exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".coupon-reward-container[data-v-0fd44dfb]{border:1px solid #dcdfe6;padding:10px;border-radius:5px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.coupon-reward-container[data-v-0fd44dfb]  .el-divider--vertical{display:inline-block;width:1px;height:2em;margin:0 8px;vertical-align:middle;position:relative}", ""]);

// exports
